import { initHeroSlider } from './slider-hero.js';
import { initAdvSlider } from './slider-adv.js';
import { initBrandsSlider } from './slider-brands.js';
import { initCatalogSlider } from './slider-catalog.js';
import { initNewsSlider } from './slider-news.js';
import { initAboutSlider } from './slider-about.js';
import { initCatalogLinksSlider } from './slider-catalog-links.js';
import { initBrandsPopularSlider } from './slider-brands-popular.js';
import { initBrandsAllSlider } from './slider-brands-all.js';
import { initBrandsFilter } from './slider-brands-filter.js';
import { initSliderProduct } from './slider-product.js';
import { initQwizStep } from './slider-qwiz.js';

export const initSliders = () => {
  initHeroSlider();
  initCatalogSlider();
  initNewsSlider();
  initAdvSlider();
  initBrandsSlider();
  initAboutSlider();
  initCatalogLinksSlider();
  initBrandsPopularSlider();
  initBrandsAllSlider();
  initBrandsFilter();
  initSliderProduct();
  initQwizStep();
};
